import React, { useState } from 'react';
import { EmployeeHeadcountCustomReport, ExpenseCustomReport, ImprestCustomReport } from './ReportsTables';
import Dashboardnavbarcopy from '../../layout/Dashboardnavbarcopy';
import usePermission from '../../config/permissions';

const ReportsManagement = () => {

    const [toggleState, setToggleState] = useState(3);
    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1:
                return 'Custom Attendance Excel';
            case 2:
                return 'Custom Imprest Excel';
            case 3:
                return 'Custom Expense Excel';
            default:
                return 'Custom Reports';
        }
    };

    return (
        <>
            <Dashboardnavbarcopy name={getSelectedTitle()} url="Custom Reports Management" />
            {/* {sessionStorage.getItem('department') === 'b3e3afd9-97e4-402f-85eb-4c22599ee5e8' ? */}
            <div className="bloc-tabss2  wfm-margin">
                {/* <button
                    className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading"}
                    onClick={() => setToggleState(1)}
                >
                    Attendance Report
                </button> */}
                {/* < button
                    className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading"}
                    onClick={() => setToggleState(2)}
                >
                    Imprest Report
                </button> */}
                <button
                    className={toggleState === 3 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading"}
                    onClick={() => setToggleState(3)}
                >
                    Expense Report
                </button>
                <button
                    className={toggleState === 4 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading"}
                    onClick={() => setToggleState(4)}
                >
                    Employee Headcount Stats
                </button>
            </div>
            {/* : null */}
            {/* } */}
            <div>
                {/* {toggleState === 1 ? <AttendanceCustomReport /> : null} */}
                {toggleState === 2 ? <ImprestCustomReport /> : null}
                {toggleState === 3 ? <ExpenseCustomReport /> : null}
                {toggleState === 4 ? <EmployeeHeadcountCustomReport /> : null}
            </div>
        </>
    );
};

export default ReportsManagement;